import {
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
	withUsagesEndpoint,
} from "@dgs/core";
import { IndustryIndexResource, IndustrySaveRequest, IndustryUpdateResource } from "../types";

const baseKey = ["industries"];

export const industryService = {
	...withIndexEndpoint<IndustryIndexResource>(baseKey),
	...withShowEndpoint<IndustryUpdateResource>(baseKey),
	...withStoreEndpoint<IndustrySaveRequest>(baseKey),
	...withUpdateEndpoint<IndustrySaveRequest>(baseKey),
	...withDestroyEndpoint(baseKey),
	...withUsagesEndpoint(baseKey),
};
